module.exports = __webpack_public_path__ + "img/district.0b80e74b.svg";